/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Footer from "./footer";

/* Styles */
import styles from "./styles";

const DeleteActionModal = ({ showModal, setShowModal, modalIcon, modalTitle, modalDescription, submitCallback, setSelectedRow, disableSubmit, submitText, cancelCallback, btnSpinner }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const handleSaveModal = () => {
    submitCallback()
  }

  return (
    <UCModal
      className={ classes.modal }
      showModal={ showModal }
      setShowModal={ setShowModal }
      modalIcon={ modalIcon }
      modalTitle={ modalTitle }
      modalDescription={ modalDescription }
      modalFooter={
        <Footer
          setShowModal={setShowModal}
          handleSaveModal={handleSaveModal}
          disableSubmit={disableSubmit}
          submitText={submitText}
          btnSpinner={ btnSpinner }
          cancelCallback={cancelCallback}
        />
      }
      dataTestId="deleteactionmodal"
      onExited={() => setSelectedRow(false)}
    />
  )
}

export default DeleteActionModal;
